/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_Q2Inputs */

const en_directory_home_faq_q2 = /** @type {(inputs: Directory_Home_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are tools scored?`)
};

const zh_directory_home_faq_q2 = /** @type {(inputs: Directory_Home_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具是怎么评分的？`)
};

/**
* | output |
* | --- |
* | "How are tools scored?" |
*
* @param {Directory_Home_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_q2 = /** @type {((inputs?: Directory_Home_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_q2(inputs)
	return zh_directory_home_faq_q2(inputs)
});
export { directory_home_faq_q2 as "directory.home.faq.q2" }